import { memo } from 'react';

import { Heading, Text } from '@/components/core';
import { TriggerHeader } from '@/components/flow';
import { PowerAutomateLogo } from '@/components/logos';

export type PowerAutomateTriggerNodeContentProps = {
  agentId: string;
  actionId: string;
};

const IPowerAutomateTriggerNodeContent = ({ agentId, actionId }: PowerAutomateTriggerNodeContentProps) => {
  return (
    <>
      <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
        <TriggerHeader agentId={agentId} actionId={actionId}>
          <PowerAutomateLogo size="lg" />
          <Heading size="lg">Import from Power Automate</Heading>
        </TriggerHeader>
      </div>
      <div className="flex gap-2 pt-2">
        <Text>When a document is submitted from a Power Automate flow.</Text>
      </div>
    </>
  );
};

export const PowerAutomateTriggerNodeContent = memo(
  IPowerAutomateTriggerNodeContent
) as typeof IPowerAutomateTriggerNodeContent;
